/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import {range} from 'ramda';

const Wrapper = styled.div`
	display: flex;
	justify-content: space-around;
	flex-flow: wrap;
	width: ${({width}) => width ? width : '187px'};
`;

const Input = styled.button`
	flex: 0 1 31%;
	font-size: 21px;
	color: #707070;
	background-color: #e5e8ea;
	padding: 10px 0 20px;
	border: none;
	margin-bottom: 5px;

	&:first-child {
		order: 1;
	}

	&:hover,
	&:active {
		background-color: #d5d8da;
	}
`;

const InputNumpad = ({
                         width,
                         handleClick,
                     }) => (
    <Wrapper width={width}>
        {range(0, 10).map(val => (
            <Input key={`numpad-input-${val})`} onClick={() => handleClick(val)}>{val}</Input>
        ))}
    </Wrapper>
);

export default InputNumpad;


// WEBPACK FOOTER //
// ./src/components/general/input-numpad.js